export default __webpack_public_path__ + "static/Metal_Sign-03a913c916ded09e51dc2ae61c65c97a.png";